import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDateNow } from "../../utils/hooks";
import classes from './TextTime.module.scss';
import { getFullDate, getTimeLabel } from './Time';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
const TextTime = ({ text, time, displayFullDate = false }) => {
    console.warn('TextTime is eprecated, use @ucc-messaging/inbox-common-ui instead');
    const now = useDateNow();
    const { t } = useTranslation();
    return (_jsxs("span", Object.assign({ className: classes.content }, { children: [_jsx("span", Object.assign({ className: classes.fullContent }, { children: text }), void 0), _jsx("span", Object.assign({ className: classNames(classes.time, classes.fullContent) }, { children: displayFullDate ? getFullDate(time) : getTimeLabel(time, now, t) }), void 0)] }), void 0));
};
export default TextTime;
//# sourceMappingURL=TextTime.js.map